/* istanbul ignore file */
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccessErrorComponent } from './shared/composants/errors/access-error/access-error.component';
import { moduleGuard } from './core/guard/module.guard';
import { Modules } from './shared/utils/logistique-pn';
import { authenticatedGuard } from './core/guard/authenticated.guard';
import { Scopes } from './core/const/scopes';

export const routes: Routes = [
  {
    path: '',
    redirectTo: `/home`,
    pathMatch: 'full',
  },
  {
    path: 'home',
    loadChildren: () => import('./modules/home/home.routes').then((m) => m.ACTIVITY_ROUTES),
    canActivate: [authenticatedGuard],
    data: {
      moduleName: Modules.Activity,
    },
  },
  {
    path: 'access-error',
    component: AccessErrorComponent,
  },
  {
    path: 'shuttle',
    loadChildren: () => import('./modules/shuttle/shuttle.module').then((m) => m.ShuttleModule),
    canActivate: [moduleGuard, authenticatedGuard],
    data: {
      moduleName: Modules.Shuttle,
      requiredScopes: [Scopes.SHUTTLES_WRITE, Scopes.SHUTTLES_READ],
    },
  },
  {
    path: 'taxi-and-pickup',
    loadChildren: () => import('./modules/taxi/taxi.module').then((m) => m.TaxiModule),
    canActivate: [moduleGuard, authenticatedGuard],
    data: {
      moduleName: Modules.TaxiAndPickup,
      requiredScopes: [Scopes.TAXIS_WRITE, Scopes.TAXIS_READ],
    },
  },
  {
    path: 'meal-tray',
    loadChildren: () =>
      import('./modules/meal-tray/meal-tray.module').then((m) => m.MealTrayModule),
    canActivate: [moduleGuard, authenticatedGuard],
    data: { moduleName: Modules.MealTray, requiredScopes: [Scopes.PEQ_WRITE, Scopes.PEQ_READ] },
  },
  {
    path: 'compensation',
    loadChildren: () =>
      import('./modules/compensation/compensation.module').then((m) => m.CompensationModule),
    canActivate: [moduleGuard, authenticatedGuard],
    data: {
      moduleName: Modules.Compensation,
      requiredScopes: [Scopes.MEAL_COMPENSATION_WRITE, Scopes.MEAL_COMPENSATION_READ],
    },
  },
  {
    path: 'logistic-point',
    loadChildren: () =>
      import('./modules/logistic-point/logistic-point.module').then((m) => m.LogisticPointModule),
    canActivate: [moduleGuard, authenticatedGuard],
    data: {
      moduleName: Modules.LogisticPoint,
      requiredScopes: [Scopes.POINTS_WRITE],
    },
  },
  {
    path: 'settings',
    loadChildren: () => import('./modules/settings/settings.module').then((m) => m.SettingsModule),
    canActivate: [moduleGuard, authenticatedGuard],
    data: { moduleName: Modules.Settings, requiredScopes: [Scopes.PARAMETERS_WRITE] },
  },
  {
    path: 'car-rental',
    loadChildren: () =>
      import('./modules/car-rental/car-rental.routes').then((m) => m.CAR_RENTAL_ROUTES),
    canActivate: [moduleGuard, authenticatedGuard],
    data: {
      moduleName: Modules.CarRental,
      requiredScopes: [
        Scopes.VOI_WRITE,
        Scopes.VOI_READ,
        Scopes.VDS_WRITE,
        Scopes.VDS_READ,
        Scopes.VDC_READ,
        Scopes.VDC_WRITE,
      ],
    },
  },
  {
    path: 'hotel',
    loadChildren: () => import('./modules/hotel/hotel.routes').then((m) => m.HOTEL_ROUTES),
    canActivate: [moduleGuard, authenticatedGuard],
    data: {
      moduleName: Modules.Hotel,
      requiredScopes: [Scopes.HOTEL_READ, Scopes.HOTEL_WRITE],
    },
  },
  {
    path: 'pickups-hotel',
    loadChildren: () =>
      import('./modules/pickups-hotel/pickups-hotel.routes').then((m) => m.PICKUPS_HOTEL_ROUTES),
    canActivate: [moduleGuard, authenticatedGuard],
    data: {
      moduleName: Modules.PickupsHotel,
      requiredScopes: [Scopes.PICKUP_READ, Scopes.PICKUP_WRITE],
    },
  },
  {
    path: '**',
    redirectTo: `/home`,
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
